var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"image logo",class:_vm.size},[_c('img',{attrs:{"src":_vm.logo || require('@/assets/icons/logo.svg'),"alt":"Program Logo"},on:{"error":_vm.programLogoOnError}})])}
var staticRenderFns = []

export { render, staticRenderFns }